import Modernizr from 'modernizr';
import ImagesLoaded from "imagesloaded";
import Accordion from './modules/accordion'

$(() => {

  // change viewport
  const ua = navigator.userAgent
  if ((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
    $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">')
  } else {
    $('head').prepend('<meta name="viewport" content="width=1040">')
  }

  // sticky header
  const headerElm = $('.header')
  let startPosition   = 0,
      windowScrollTop = 0
  $(window).on('scroll', event => {
    windowScrollTop = $(event.currentTarget).scrollTop()
    if (windowScrollTop > startPosition) {
      if(windowScrollTop >= 200){
        headerElm.addClass('hide')
      }
    }else if(windowScrollTop < startPosition) {
      headerElm.removeClass('hide')
    }
    startPosition = windowScrollTop
    if(windowScrollTop > 0) {
      headerElm.addClass('sticky')
    } else {
      headerElm.removeClass('sticky')
    }
  })
  // 初期表示でheaderを隠す
  if ($(window).scrollTop() > 0) headerElm.addClass('sticky hide')

  // global navigation dropdown menu
  const dropdownmenu = $('.dropdownMenu')
  dropdownmenu.on('mouseenter', event => {
    console.log($(event.currentTarget).find('.dropdownMenu__child'))
    $(event.currentTarget).find('.dropdownMenu__child').addClass('test')
  })
  dropdownmenu.on('mouseleave', event => {
    $(event.currentTarget).find('.dropdownMenu__child').removeClass('test')
  })

  // drawer menu
  $('.menuButton, .overray').on('click', event => {
    const drawerElm  = $('.drawer')
    let windowHeight = $(window).innerHeight(),
        headerHeight = headerElm.innerHeight(),
        drawerHeight = $('.drawer__inner').innerHeight()
    if(!drawerElm.hasClass('open')) {
      drawerElm.css({
        height: drawerHeight,
        maxHeight: windowHeight - headerHeight
      })
    } else {
      drawerElm.removeAttr('style')
    }
    $('.menuButton').toggleClass('open')
    $('body, .overray').toggleClass('open')
    drawerElm.toggleClass('open').css('top', headerHeight - 1)
  })

  // accordion
  Accordion()

})



// WEBPACK FOOTER //
// ./src/assets/js/scripts.js